import { render } from "./cut_sys.vue?vue&type=template&id=31d474ba&scoped=true"
import script from "./cut_sys.vue?vue&type=script&lang=js"
export * from "./cut_sys.vue?vue&type=script&lang=js"

import "./cut_sys.vue?vue&type=style&index=0&id=31d474ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d474ba"]])

export default __exports__